import devNote from '@xingternal/malt-util/dev-note';
export default function trackToLocalStorage({ key, data, url }) {
    const existingEntries = JSON.parse(window.localStorage.getItem(key)) || [];
    const tracking = {
        data: JSON.stringify(data),
        src: url,
    };
    try {
        window.localStorage.setItem(key, JSON.stringify(existingEntries.concat([tracking])));
    }
    catch (e) {
        devNote.error(e);
    }
}
//# sourceMappingURL=tracking.js.map